import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import Vimeo from '@u-wave/react-vimeo'

const customStyles = {
	overlay: {
		position: 'fixed',
		zIndex: 1020,
		top: 0,
		left: 0,
		width: '100vw',
		height: '100vh',
		background: 'rgba(255, 255, 255, 0.75)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
}

interface IVideoProps {
	isVideoPlayerOpen: boolean
	closeModal: () => void
}

const Video: React.FC<IVideoProps> = ({ isVideoPlayerOpen, closeModal }) => {
	function afterOpenModal() {
		document.body.classList.add('no-scroll')
	}

	function afterCloseModal() {
		document.body.classList.remove('no-scroll')
	}

	return (
		<Modal
			isOpen={isVideoPlayerOpen}
			onAfterOpen={afterOpenModal}
			onAfterClose={afterCloseModal}
			onRequestClose={closeModal}
			ariaHideApp={false}
			style={{
				overlay: {
					position: 'fixed',
					zIndex: 1020,
					top: 0,
					left: 0,
					width: '100vw',
					height: '100vh',
					background: 'rgba(0, 0, 0, 0.65)',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				},
			}}
			className='modal'
			contentLabel='Example Modal'
		>
			<Vimeo video={795055130} className='vimeo-player' autoplay color={'rgba(255, 255, 255, 0.5)'} showByline={false} />
		</Modal>
	)
}

export default Video
